const PasswordRow = (props) => {
    const {children, isFirstRow} = props;
    return (
        <div data-testid="password-row" className={isFirstRow ? '' : 'mt-5'}>
            {children}
        </div>
    );
}

export default PasswordRow;